import type { GuardrailConflictType } from "@models/Dataset";

export const CONFLICT_LABELS: Record<GuardrailConflictType, string> = {
  DISABLED_TIME_SERIES_UNIT: "Uses a disabled time-series unit",
  DISABLED_POINT_IN_TIME_UNIT: "Uses a disabled point-in-time unit",
  INVALID_TIME_SERIES_ROLLING_AVERAGE: "Uses a rolling average no longer allowed for the selected time-series unit",
  INVALID_POINT_IN_TIME_ROLLING_AVERAGE: "Uses a rolling average no longer allowed for the selected point-in-time unit",
};

export const CONFLICT_CHIP_LABELS: Record<GuardrailConflictType, string> = {
  DISABLED_TIME_SERIES_UNIT: "Disabled time-series unit",
  DISABLED_POINT_IN_TIME_UNIT: "Disabled point-in-time unit",
  INVALID_TIME_SERIES_ROLLING_AVERAGE: "Invalid rolling average (time-series)",
  INVALID_POINT_IN_TIME_ROLLING_AVERAGE: "Invalid rolling average (point-in-time)",
};

export const CONFLICT_COLOR: Record<GuardrailConflictType, "error" | "warning"> = {
  DISABLED_TIME_SERIES_UNIT: "error",
  DISABLED_POINT_IN_TIME_UNIT: "error",
  INVALID_TIME_SERIES_ROLLING_AVERAGE: "warning",
  INVALID_POINT_IN_TIME_ROLLING_AVERAGE: "warning",
};

export const WIDGET_TYPE_LABELS: Record<string, string> = {
  line: "Line Chart",
  bar: "Bar Chart",
  table: "Table",
  crosstab: "Crosstab",
  pie: "Pie Chart",
  donut: "Donut Chart",
};
